<template>
  <div class="order-execute">
    <div class="order-execute_text-wrapper">
      <label
        class="order-execute_subscribe"
        for="subscribe">
        <input
          id="subscribe"
          name="subscribe"
          type="checkbox"
          :checked="getIsSubscribe"
          @change="onChangeCheckbox">
        <span class="checkbox-mark"></span>
        <div class="checkbox-text">Получать информацию о новинках и акциях</div>
      </label>
      <div class="order-execute_policy">
        Подтверждая заказ, вы автоматически соглашаетесь с <a target="_blank" :href="offerUrl">договором публичной оферты</a> и согласны
        на обработку ваших
        <a :href="policyUrl">персональных данных</a>
      </div>
    </div>
    <div
      class="order-execute_btn"
      :class="{active: isOrderSuccess}"
      @click="onOrderClick">
      Отправить заказ
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapMutations, mapActions} from 'vuex'

  export default {
    name: 'ExecuteOrder',
    data: function () {
      return {
        offerUrl: '/help/payment/договор_оферта.pdf',
        policyUrl: '#'
      }
    },
    computed: {
      ...mapGetters('order', [
        'getIsSubscribe',
        'getValidateUserInfo',
        'getValidateDelivery',
        'getDeliveryItems'
      ]),
      isOrderSuccess: function () {
        return this.getValidateUserInfo && this.getValidateDelivery && Object.keys(this.getDeliveryItems).length > 0
      }
    },
    methods: {
      ...mapMutations('order', [
        'setIsSubscribe'
      ]),
      ...mapActions('order', [
        'saveOrder'
      ]),
      onChangeCheckbox: function (e) {
        let val = e.target.checked
        this.setIsSubscribe(val)
      },
      onOrderClick: function () {
        if (this.isOrderSuccess) {
          this.saveOrder()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Order/ExecuteOrder.vue